import { render, staticRenderFns } from "./FeedbackOverview.vue?vue&type=template&id=02593b51"
import script from "./FeedbackOverview.vue?vue&type=script&lang=js"
export * from "./FeedbackOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports